import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Alert,
  Avatar,
  Box,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import StorefrontIcon from '@material-ui/icons/Storefront';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import swal from 'sweetalert';
import Api from '../../utils/api';
import Diversos from '../../utils/diversos';

const UsuarioListResult = ({
  regs,
  setRegs,
  orderby,
  setOrderby,
  page,
  setPage,
  perPage,
  setPerPage,
  total,
  query,
  ...rest
}) => {
  const api = new Api();
  const diversos = new Diversos();
  const auth = useSelector((state) => state.auth);

  const handleInactivate = async (param) => {
    swal({
      title: 'Confirma a inativação?',
      text: `Deseja inativar o usuário ${param.name}? Ele será desconectado e não poderá mais fazer login.`,
      icon: 'warning',
      buttons: {
        cancel: 'Não',
        confirma: {
          text: 'Sim, Inativar',
          value: true,
          closeModal: false
        }
      },
      dangerMode: true
    })
      .then((willInactivate) => {
        if (!willInactivate) {
          throw null; // eslint-disable-line
        }

        return api.put(`/users/${param.id}/inactivate`, {}, auth.token);
      })
      .then(({ data }) => {
        swal('Sucesso', 'Usuário inativado com sucesso', 'success').then(() => {
          window.location.reload();
        });
      })
      .catch((e) => {
        if (e) {
          swal('Atenção', 'Não foi possível inativar usuário', 'error');
        } else {
          swal.stopLoading();
          swal.close();
        }
      });
  };

  const handleActivate = async (param) => {
    swal({
      title: 'Confirma a ativação?',
      text: `Deseja reativar o usuário ${param.name}?`,
      icon: 'info',
      buttons: {
        cancel: 'Não',
        confirma: {
          text: 'Sim, Ativar',
          value: true,
          closeModal: false
        }
      }
    })
      .then((willActivate) => {
        if (!willActivate) {
          throw null; // eslint-disable-line
        }

        return api.put(`/users/${param.id}/activate`, {}, auth.token);
      })
      .then(({ data }) => {
        swal('Sucesso', 'Usuário reativado com sucesso', 'success').then(() => {
          window.location.reload();
        });
      })
      .catch((e) => {
        if (e) {
          swal('Atenção', 'Não foi possível reativar usuário', 'error');
        } else {
          swal.stopLoading();
          swal.close();
        }
      });
  };

  const handleDelete = async (param) => {
    swal({
      title: 'Confirma a exclusão?',
      text: `Deseja realmente apagar o usuário ${param.name}?`,
      icon: 'warning',
      buttons: {
        cancel: 'Não',
        confirma: {
          text: 'Sim',
          value: true,
          closeModal: false
        }
      },
      dangerMode: true
    })
      .then((willDelete) => {
        if (!willDelete) {
          throw null; // eslint-disable-line
        }

        return api.delete(`/users/${param.id}`, auth.token);
      })
      .then(({ data }) => {
        swal('Sucesso', 'Usuário excluído com sucesso', 'success').then(() => {
          window.location.reload();
        });
      })
      .catch((e) => {
        if (e) {
          swal('Atenção', 'Não foi possível excluir usuário', 'error');
        } else {
          swal.stopLoading();
          swal.close();
        }
      });
  };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>E-mail</TableCell>
                <TableCell>Admin</TableCell>
                <TableCell>Status</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {regs.length <= 0 ? (
                <TableRow key={0}>
                  <TableCell colSpan={5}>
                    <Alert severity="warning">Nenhum usuário localizado</Alert>
                  </TableCell>
                </TableRow>
              ) : (
                regs.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      <Typography variant="body1">
                        {row.name}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.is_admin ? 'Sim' : 'Não'}</TableCell>
                    <TableCell>
                      {row.active ? (
                        <Typography variant="body2" style={{ color: '#4caf50', fontWeight: 500 }}>
                          Ativo
                        </Typography>
                      ) : (
                        <Typography variant="body2" style={{ color: '#f44336', fontWeight: 500 }}>
                          Inativo
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: 'right'
                      }}
                    >
                      <Link to={`/app/usuario/${row.id}/view`}>
                        <IconButton size="small">
                          <VisibilityIcon />
                        </IconButton>
                      </Link>
                      <Link to={`/app/usuario/${row.id}/edit`}>
                        <IconButton size="small">
                          <EditIcon />
                        </IconButton>
                      </Link>
                      {!row.is_admin && (
                        row.active ? (
                          <IconButton
                            size="small"
                            onClick={() => handleInactivate(row)}
                            title="Inativar usuário"
                            style={{ color: '#f44336' }}
                          >
                            <BlockIcon />
                          </IconButton>
                        ) : (
                          <IconButton
                            size="small"
                            onClick={() => handleActivate(row)}
                            title="Ativar usuário"
                            style={{ color: '#4caf50' }}
                          >
                            <CheckCircleIcon />
                          </IconButton>
                        )
                      )}
                      <IconButton size="small" onClick={() => handleDelete(row)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        // eslint-disable-next-line no-shadow
        onPageChange={(event, page) => {
          setPage(page + 1);
          query.set('page', page + 1);
          window.location.search = query.toString();
        }}
        onRowsPerPageChange={(event) => {
          setPerPage(event.target.value);
          query.set('perPage', event.target.value);
          window.location.search = query.toString();
        }}
        page={page - 1}
        rowsPerPage={perPage}
        rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
        labelDisplayedRows={
          (
            { from, to, count } // eslint-disable-next-line
          ) => `${from}-${to} de ${count !== -1 ? count : to}` // eslint-disable-next-line
        } // eslint-disable-next-line
        labelRowsPerPage="Linhas por página:"
      />
    </Card>
  );
};

UsuarioListResult.propTypes = {
  regs: PropTypes.array.isRequired,
  setRegs: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  setPerPage: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  orderby: PropTypes.string.isRequired,
  setOrderby: PropTypes.func.isRequired,
  query: PropTypes.any.isRequired
};

export default UsuarioListResult;
